/* =========================================================
   VS SHOP — Shopify theme JS
   ========================================================= */

(function () {
  'use strict';

  /* ------- Helpers ------- */
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  const formatMoney = (cents) => {
    const fmt = (window.theme && window.theme.moneyFormat) || '€{{amount}}';
    const value = (cents / 100).toFixed(2).replace('.', ',');
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, value);
  };

  /* ------- Sticky header shadow ------- */
  const header = $('[data-site-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ------- Drawers (cart / search / mobile menu) ------- */
  const drawers = {};
  $$('[data-drawer]').forEach((drawer) => {
    drawers[drawer.dataset.drawer] = drawer;
  });
  const overlay = $('[data-drawer-overlay]');

  function openDrawer(name) {
    Object.values(drawers).forEach((d) => d.classList.remove('is-open'));
    if (drawers[name]) drawers[name].classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    Object.values(drawers).forEach((d) => d.classList.remove('is-open'));
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  $$('[data-drawer-open]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      openDrawer(btn.dataset.drawerOpen);
    });
  });
  $$('[data-drawer-close]').forEach((btn) => {
    btn.addEventListener('click', closeDrawer);
  });
  if (overlay) overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });

  /* ------- Cart fetch + render ------- */
  async function fetchCart() {
    const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    return res.json();
  }

  function renderCartCount(count) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function renderCartDrawer(cart) {
    const body = $('[data-cart-body]');
    const footer = $('[data-cart-footer]');
    if (!body) return;
    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-empty">Il tuo carrello è vuoto</div>';
      if (footer) footer.hidden = true;
      return;
    }
    if (footer) footer.hidden = false;
    body.innerHTML = cart.items.map((item) => `
      <div class="cart-item" data-cart-item data-key="${item.key}">
        <div class="cart-item__img"><img src="${item.image ? item.image.replace(/(\.[^.]+)$/, '_200x$1') : ''}" alt="${item.title}"></div>
        <div>
          <div class="cart-item__title">${item.product_title}</div>
          ${item.variant_title ? `<div class="cart-item__meta">${item.variant_title}</div>` : ''}
          <div class="cart-item__price">${formatMoney(item.final_line_price)}</div>
          <div class="cart-item__qty">
            <button type="button" data-qty-change="-1" aria-label="Diminuisci">−</button>
            <input type="number" min="0" value="${item.quantity}" data-qty-input>
            <button type="button" data-qty-change="1" aria-label="Aumenta">+</button>
          </div>
          <a href="#" class="cart-item__remove" data-cart-remove>Rimuovi</a>
        </div>
      </div>
    `).join('');
    const total = $('[data-cart-total]');
    if (total) total.textContent = formatMoney(cart.total_price);
  }

  async function refreshCart(open = false) {
    const cart = await fetchCart();
    renderCartCount(cart.item_count);
    renderCartDrawer(cart);
    if (open) openDrawer('cart');
  }

  async function updateLine(key, qty) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
    const cart = await res.json();
    renderCartCount(cart.item_count);
    renderCartDrawer(cart);
  }

  document.addEventListener('click', (e) => {
    const removeBtn = e.target.closest('[data-cart-remove]');
    if (removeBtn) {
      e.preventDefault();
      const item = removeBtn.closest('[data-cart-item]');
      updateLine(item.dataset.key, 0);
      return;
    }
    const qtyBtn = e.target.closest('[data-qty-change]');
    if (qtyBtn) {
      const item = qtyBtn.closest('[data-cart-item]');
      const input = $('[data-qty-input]', item);
      const next = Math.max(0, parseInt(input.value, 10) + parseInt(qtyBtn.dataset.qtyChange, 10));
      updateLine(item.dataset.key, next);
    }
  });

  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-qty-input]');
    if (!input) return;
    const item = input.closest('[data-cart-item]');
    updateLine(item.dataset.key, Math.max(0, parseInt(input.value, 10) || 0));
  });

  /* ------- Add to cart (product form) ------- */
  $$('[data-product-form]').forEach((form) => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[data-add-btn]');
      if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = '...'; }
      try {
        const fd = new FormData(form);
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: fd
        });
        if (!res.ok) {
          const err = await res.json();
          alert(err.description || 'Impossibile aggiungere al carrello');
        } else {
          await refreshCart(true);
        }
      } catch (err) {
        console.error(err);
      } finally {
        if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label || 'Aggiungi'; }
      }
    });
  });

  /* ------- Variant picker ------- */
  $$('[data-variant-picker]').forEach((picker) => {
    const form = picker.closest('form') || document.querySelector('[data-product-form]');
    const variantsData = JSON.parse(picker.dataset.variants || '[]');
    const idInput = form ? form.querySelector('[name="id"]') : null;
    const priceEl = $('[data-product-price]');
    const compareEl = $('[data-product-compare]');
    const addBtn = form ? form.querySelector('[data-add-btn]') : null;

    function findVariant() {
      const selectedOpts = $$('input[type="radio"]:checked', picker).map((i) => i.value);
      return variantsData.find((v) =>
        v.options.every((opt, idx) => opt === selectedOpts[idx])
      );
    }
    function updateUI() {
      const v = findVariant();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = formatMoney(v.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available
          ? (window.theme.strings.addToCart || 'Aggiungi')
          : (window.theme.strings.soldOut || 'Esaurito');
      }
      // update URL with variant
      if (history.replaceState && v.id) {
        const url = new URL(window.location);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url);
      }
    }
    picker.addEventListener('change', updateUI);
    updateUI();
  });

  /* ------- Predictive search ------- */
  const searchInput = $('[data-search-input]');
  const searchResults = $('[data-search-results]');
  if (searchInput && searchResults) {
    let t;
    searchInput.addEventListener('input', () => {
      clearTimeout(t);
      const q = searchInput.value.trim();
      if (q.length < 2) { searchResults.innerHTML = ''; return; }
      t = setTimeout(async () => {
        try {
          const res = await fetch(`${window.theme.routes.predictive_search_url}?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&section_id=predictive-search`);
          const text = await res.text();
          searchResults.innerHTML = text;
        } catch (e) { console.error(e); }
      }, 200);
    });
  }

  /* ------- Initial cart load ------- */
  fetchCart().then((cart) => renderCartCount(cart.item_count)).catch(() => {});

  /* ------- Reveal on scroll ------- */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.01, rootMargin: '0px 0px -10% 0px' });
    $$('[data-reveal]').forEach((el) => {
      // se già nel viewport al load, mostra subito senza attendere observer
      const rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        el.classList.add('is-visible');
      } else {
        io.observe(el);
      }
    });
  } else {
    $$('[data-reveal]').forEach((el) => el.classList.add('is-visible'));
  }
  /* ------- Initial cart load ------- */
  fetchCart().then((cart) => renderCartCount(cart.item_count)).catch(() => {});

  /* ------- Video click-to-play ------- */
  $$('[data-video-play]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const wrap = btn.closest('[data-video-wrap]');
      const tpl = wrap && wrap.querySelector('[data-video-template]');
      if (!tpl) return;
      const node = tpl.content ? tpl.content.cloneNode(true) : (() => {
        const div = document.createElement('div');
        div.innerHTML = tpl.innerHTML;
        return div;
      })();
      btn.replaceWith(node);
    });
  });

  /* ------- Force autoplay on iOS (Low Power Mode workaround) ------- */
  const autoplayVideos = $$('video[data-autoplay]');
  function tryPlay(v) {
    if (!v) return;
    // muted è critico per autoplay mobile; ri-assicuriamoci
    v.muted = true;
    v.defaultMuted = true;
    v.playsInline = true;
    v.setAttribute('muted', '');
    v.setAttribute('playsinline', '');
    const p = v.play();
    if (p && typeof p.catch === 'function') {
      p.catch(() => {
        // autoplay rifiutato: ri-tentiamo dopo prima interazione utente
        const retry = () => { v.play().catch(() => {}); cleanup(); };
        const cleanup = () => {
          ['touchstart', 'click', 'scroll', 'keydown'].forEach((ev) =>
            document.removeEventListener(ev, retry, { passive: true, capture: true })
          );
        };
        ['touchstart', 'click', 'scroll', 'keydown'].forEach((ev) =>
          document.addEventListener(ev, retry, { passive: true, capture: true, once: true })
        );
      });
    }
  }
  autoplayVideos.forEach((v) => {
    if (v.readyState >= 2) {
      tryPlay(v);
    } else {
      v.addEventListener('loadedmetadata', () => tryPlay(v), { once: true });
      v.addEventListener('canplay', () => tryPlay(v), { once: true });
    }
  });

  // metti in pausa i video fuori dal viewport per risparmiare batteria
  if ('IntersectionObserver' in window && autoplayVideos.length) {
    const vIO = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const v = entry.target;
        if (entry.isIntersecting) {
          if (v.paused) v.play().catch(() => {});
        } else {
          if (!v.paused) v.pause();
        }
      });
    }, { threshold: 0.1 });
    autoplayVideos.forEach((v) => vIO.observe(v));
  }
})();
